// extracted by mini-css-extract-plugin
export default {"equilateral":"ShapeWrapper_equilateral__aLhTF","square":"ShapeWrapper_square__edsNA","inner":"ShapeWrapper_inner__PqtnR","circle":"ShapeWrapper_circle__y4XGy"};